import { useUser } from "../contexts/UserContext";

export const usePermissions = () => {
  const {
    isOrgAdmin,
    isBusinessUnitHead,
    isBusinessUser,
    canManageOrganization,
    canManageBusinessUnit,
    isBusinessUnitMember,
    userProfile,
  } = useUser();

  return {
    // Role checks
    isOrgAdmin,
    isBusinessUnitHead,
    isBusinessUser,

    // Permission checks
    canManageOrganization,
    canManageBusinessUnit,
    isBusinessUnitMember,

    // UI visibility helpers
    canSeeAdminFeatures: isOrgAdmin,
    canSeeBusinessUnitManagement: isOrgAdmin || isBusinessUnitHead,
    canAssignBusinessUnitHeads: isOrgAdmin,
    canAssignBusinessUsers: isOrgAdmin || isBusinessUnitHead,
    canCreateOrganizations: isOrgAdmin,
    canCreateBusinessUnits: isOrgAdmin,

    // Data access helpers
    getAccessibleOrganizations: () =>
      userProfile?.permissions?.organizations || [],
    getAccessibleBusinessUnits: () => [
      ...(userProfile?.permissions?.businessUnitHeadOf || []),
      ...(userProfile?.permissions?.businessUnitMemberOf || []),
    ],

    // Specific permission checks
    canAccessControl: (controlId) => {
      // Business users can only access assigned controls
      if (isBusinessUser) {
        // This would need to be implemented based on assigned controls
        return false; // Placeholder - will need backend support
      }
      return isOrgAdmin || isBusinessUnitHead;
    },

    // Business unit specific permissions
    canManageSpecificBusinessUnit: (businessUnitId) => {
      if (isOrgAdmin) return true;
      return (
        userProfile?.permissions?.businessUnitHeadOf?.some(
          (bu) => bu.id === businessUnitId
        ) || false
      );
    },

    // Organization specific permissions
    canManageSpecificOrganization: (organizationId) => {
      return (
        userProfile?.permissions?.organizations?.some(
          (org) => org.id === organizationId && org.role === "admin"
        ) || false
      );
    },

    // Invite-related permissions
    canSendInvites: isOrgAdmin || isBusinessUnitHead,
    canSendOrgAdminInvites: isOrgAdmin,
    canSendBusinessUnitHeadInvites: isOrgAdmin,
    canSendBusinessUserInvites: isOrgAdmin || isBusinessUnitHead,
    canManageInvites: isOrgAdmin || isBusinessUnitHead,
  };
};
